import type { ViduV1ExploreDetailProReply } from '@/app/types';
import { LANGUAGE_CONFIG } from '@/i18n/config';
import { type FeedDetailType, getContentMetadata } from '../feed-detail';
import { generateCommunityShareUrl } from './community-share';

/**
 * 更新页面 URL 和元数据
 * @param id 内容 ID
 * @param data 详情数据
 * @param locale 当前语言
 */
export function updatePageMetadata(
  id: string,
  data: ViduV1ExploreDetailProReply,
  locale: string,
  feedType: FeedDetailType,
): void {
  const link = generateCommunityShareUrl({ id, withOrigin: false, isActivity: feedType === 'activity' });
  const isDefaultLocale = locale === LANGUAGE_CONFIG.default;
  const finalLink = isDefaultLocale ? link : `/${locale}${link}`;
  window.history.replaceState(null, '', finalLink);

  const { title, description } = getContentMetadata(data);
  if (title) {
    document.title = title;
  }
  if (description) {
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
  }
}
